import { Module } from 'vuex';
import { AxiosError } from 'axios';
import { errorStatuses } from '@/const/statuses';

interface IErrorState {
  name: string;
  message: string;
  debugInfo: string;
}

interface IErrorData extends AxiosError {
  notDebugInfo?: boolean;
}

export default <Module<IErrorState, any>>{
  state: {
    name: '',
    message: '',
    debugInfo: '',
  },
  mutations: {
    setError(state, eData: IErrorData) {
      let { name = '', message = '', config, response, code, status, notDebugInfo } = eData;
      let _errorMessage = `${name} ${message}`;
      name = name === 'AxiosError' ? 'Ошибка сервера' : 'Ошибка клиента';

      if (response) {
        if (status === 501 || status === 502) {
          name = 'Сервер временно недоступен, зайдите позже';
          _errorMessage = '';
        } else {
          //@ts-ignore
          const { message, errorMessage } = response.data;

          _errorMessage =
            message ||
            errorMessage ||
            (typeof response?.data === 'string' ? response?.data : getMessageByErrorCode(status));
        }
      }

      state.name = name;
      state.message = _errorMessage;

      const isDebug = true; //process.env.VUE_APP_DEBUG === 'true';

      if (isDebug && !notDebugInfo) {
        const params = config?.data && config.data.length < 500 ? '\n' + config.data : undefined;
        state.debugInfo = [status, config?.method, config?.url, code, params].filter((r) => r).join(' ');
      }
    },

    clearError(state) {
      state.name = '';
      state.message = '';
      state.debugInfo = '';
    },
  },
  actions: {
    setError({ commit, dispatch }, e: IErrorData) {
      // Пропускаем при разлогинивание пользователя
      if (e.response?.status === 403 || e.response?.status === 429) {
        return;
      }

      commit('setError', e);
    },
  },
  getters: {
    error: (state): IErrorState => state,
  },
};

function getMessageByErrorCode(status: number | undefined) {
  //@ts-ignore
  return status ? errorStatuses[status] || 'Неизвестная ошибка' : 'Проблема связанная с сетью';
}
